"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LabelFactory = _interopRequireDefault(require("../../common/FormElement/LabelFactory"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.dropdown {\n  width: 100%;\n  margin-bottom: 1.5rem; }\n  .dropdown .bx--label {\n    color: #4c4c4c; }\n  .dropdown .placeholder {\n    color: #a8a8a8; }\n  .dropdown .tooltip {\n    color: #a8a8a8; }\n  .dropdown.narrow {\n    width: fit-content; }\n  .dropdown .bx--dropdown--inline .placeholder {\n    color: #4c4c4c; }\n  .dropdown .bx--list-box__menu-item__option {\n    color: #4c4c4c;\n    font-size: 12px; }\n\n.bx--list-box__menu:focus {\n  outline-color: #4c4c4c; }\n\n.bx--dropdown--inline .bx--list-box__menu {\n  min-width: auto; }\n";
  const fileName = "Dropdown_Dropdown";
  const element = document.querySelector("style[data-sass-component='Dropdown_Dropdown']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Dropdown = props => {
  const dropdownRef = (0, _react.useRef)(null);
  const itemToCarbonItem = item => {
    return {
      id: item.id,
      text: item.label
    };
  };
  const carbonItemToItem = carbonItem => {
    return {
      id: carbonItem.id,
      label: carbonItem.text
    };
  };
  const filteredItems = props.items.filter(item => {
    return !(item === null || item.label === null || item.label === '');
  });
  const carbonItems = filteredItems.map(item => itemToCarbonItem(item));
  const selectedCarbonItem = props.value ? itemToCarbonItem(props.value) : null;
  let classNames = ['dropdown'];
  if (props.narrow) {
    classNames.push('narrow');
  }
  if (props.className) {
    classNames.push(props.className);
  }
  (0, _react.useEffect)(() => {
    if (dropdownRef.current) {
      if (props.inline) {
        const button = dropdownRef.current;
        const parent = dropdownRef.current.parentElement;
        const sibling = button.nextSibling;
        const childWidthes = [];
        if (props.inline) {
          button.style.maxWidth = 'none';
          sibling.style.maxWidth = 'none';
        }
        carbonItems.forEach(item => {
          let container = document.createElement('div');
          container.style.width = 'fit-content';
          container.style.zIndex = '-100';
          container.style.position = 'relative';
          let menuItem = document.createElement('div');
          menuItem.style.display = 'absolute';
          menuItem.classList.add('bx--list-box__menu-item');
          menuItem.style.font = '14px / 14px Helvetica, Arial, sans-serif';
          let option = document.createElement('div');
          option.textContent = item.text;
          option.classList.add('bx--list-box__menu-item__option');
          option.style.fontSize = '14px';
          option.style.border = 'solid black 1px';
          menuItem.append(option);
          container.append(menuItem);
          document.body.append(container);
          childWidthes.push(menuItem.clientWidth);
          container.remove();
        });
        const longestChildWidth = childWidthes.reduce((acc, e) => e > acc ? e : acc, 0);
        if (longestChildWidth < window.innerWidth) {
          parent.style.width = longestChildWidth + 8 + 'px';
        }
      }
    }
  });
  const onBlur = e => {
    if ((!e.relatedTarget || e.relatedTarget.classList.contains('bx--list-box__menu-item') || e.relatedTarget.classList.contains('bx--list-box__field')) && props.onBlur) {
      props.onBlur(e);
    }
  };
  const customLabel = /*#__PURE__*/_react.default.createElement("div", null, props.label && _LabelFactory.default.create(props.label, props.required), props.tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip"
  }, props.tooltip));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames.join(' '),
    onBlur: onBlur
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Dropdown, {
    ref: dropdownRef,
    id: props.id,
    titleText: customLabel,
    label: props.placeholder ? /*#__PURE__*/_react.default.createElement("span", {
      className: 'placeholder'
    }, props.placeholder) : '',
    items: carbonItems,
    selectedItem: selectedCarbonItem,
    itemToString: item => item.text,
    type: props.inline ? 'inline' : null,
    helperText: props.helperText,
    onChange: event => {
      const item = carbonItemToItem(event.selectedItem);
      props.onChange(event, item);
    },
    invalid: Boolean(props.invalidText),
    invalidText: props.invalidText,
    disabled: props.disabled,
    hideLabel: props.hideLabel
  }));
};
Dropdown.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: function (props) {
    if (props.inline) {
      return;
    }
    if (!props.label) {
      return new Error('Label is required for default dropdown type.');
    }
  },
  tooltip: _propTypes.default.string,
  items: _propTypes.default.array.isRequired,
  required: _propTypes.default.bool,
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.object,
  narrow: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  invalidText: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  type: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  hideLabel: _propTypes.default.bool
};
Dropdown.defaultProps = {
  type: 'Dropdown' // todo, https://stackoverflow.com/q/72446985/4840661
};
var _default = exports.default = Dropdown;